import Axios from "../../api/Axios";
const BASE_URL = "Reports/";
export const EndpointStkAdjReport = {
    GetStockAdjustmentExcel: "GetStockAdjustmentExcel",
};

export const createAPIEndpointStkAdjReport = () => {
    return {get:(Endpoint)=>Axios.get(BASE_URL+Endpoint)};
};